import { useEffect, useRef, useState } from "react";

import { Loading } from "@components";
import { ForEach, If } from "@components/control-statements";
import { CustomerCard } from "@containers/database/CustomerCard";
import { CustomerTableItem } from "@containers/database/CustomerTableItem";
import { useIsInViewport } from "@hooks";

import style from "@styles/pages/oraculo/oraculo.module.scss";

export const CUSTOMER_LIST_STYLE = {
  grid: "grid",
  table: "table",
};

export const CustomersTab = ({
  style,
  customers,
  onSelectCustomer,
  onLoadMoreData,
}) => {
  return (
    <>
      {style === CUSTOMER_LIST_STYLE.grid && (
        <CustomerGrid
          customers={customers}
          onLoadMoreData={onLoadMoreData}
          onSelectedCustomer={(customer) => onSelectCustomer(customer.id)}
        />
      )}
      {style === CUSTOMER_LIST_STYLE.table && (
        <CustomerTable
          customers={customers}
          onLoadMoreData={onLoadMoreData}
          onSelectedCustomer={(customer) => onSelectCustomer(customer.id)}
        />
      )}
    </>
  );
};

const CustomerTable = ({ customers, onSelectedCustomer, onLoadMoreData }) => {
  const [loading, setLoading] = useState(false);

  const table_end_ref = useRef(null);
  const is_visible = useIsInViewport(table_end_ref);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      onLoadMoreData && (await onLoadMoreData());
      setLoading(false);
    };

    is_visible && load();
  }, [is_visible]);

  return (
    <div className={style.table}>
      <table>
        <tbody>
          <tr>
            <th>Identificação</th>
            <th>Dados cadastrais</th>
            <th>Total gasto</th>
            <th>Conversões</th>
          </tr>
          <ForEach
            items={customers}
            render={(customer) => (
              <CustomerTableItem
                customer={customer}
                onClick={(customer) =>
                  onSelectedCustomer && onSelectedCustomer(customer)
                }
              />
            )}
          />
          <tr>
            <td colSpan={4}>
              <If cond={loading}>
                <div className={style.loading}>
                  <div className="w-100 d-flex align-center justify-center flex-1 pt-25 pb-25">
                    <Loading />
                  </div>
                </div>
              </If>
              <div ref={table_end_ref}>&nbsp;</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const CustomerGrid = ({ customers, onSelectedCustomer, onLoadMoreData }) => {
  const [loading, setLoading] = useState(false);

  const grid_end_ref = useRef(null);
  const is_visible = useIsInViewport(grid_end_ref);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      onLoadMoreData && (await onLoadMoreData());
      setLoading(false);
    };

    is_visible && load();
  }, [is_visible]);

  return (
    <>
      <div className={style.customers}>
        <ForEach
          items={customers}
          render={(customer) => (
            <CustomerCard
              customer={customer}
              onClick={(customer) =>
                onSelectedCustomer && onSelectedCustomer(customer)
              }
            />
          )}
        />
      </div>
      <If cond={loading}>
        <div className={style.loading}>
          <div className="w-100 d-flex align-center justify-center flex-1 pt-25 pb-25">
            <Loading />
          </div>
        </div>
      </If>
      <div ref={grid_end_ref}>&nbsp;</div>
    </>
  );
};
